// Loader is now a thin re-export of GlobalLoader so every existing callsite
// (BlogList "Loading…", admin pages, ContactForm submit button, Resume fetch)
// automatically uses the splashAnimation-powered unified loader.
//
// Old API preserved:
//   <Loader />                      → full-viewport
//   <Loader inline label="..." />   → embedded
import GlobalLoader from "./GlobalLoader";

export default GlobalLoader;
